// import React, { useState, useEffect, useRef } from "react";
// import { ChevronDown, Check } from "lucide-react";
// import Badge from "@mui/material/Badge";
// import "./styles.scss";

// export const CommonFilter = ({ filters, onFilterChange, initialFilters , clientDash }) => {
//   const [activeFilters, setActiveFilters] = useState(() => {
//     // Initialize with initialFilters if provided, otherwise use empty arrays
//     return filters.reduce((acc, filter) => {
//       acc[filter.id] = initialFilters?.[filter?.id] || [];
//       return acc;
//     }, {});
//   });

//   const [activeFilterDropdown, setActiveFilterDropdown] = useState(null);
//   const [searchQueries, setSearchQueries] = useState({});
//   const dropdownRefs = useRef({}); // Store refs for each dropdown

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       let isClickInside = false;

//       // Check if the clicked element is inside any active dropdown
//       Object.values(dropdownRefs.current).forEach((ref) => {
//         if (ref && ref.contains(event.target)) {
//           isClickInside = true;
//         }
//       });

//       if (!isClickInside) {
//         setActiveFilterDropdown(null);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//     if (initialFilters) {
//       setActiveFilters(prevFilters => {
//         const newFilters = { ...prevFilters };
//         Object.keys(initialFilters).forEach(key => {
//           if (initialFilters[key] && initialFilters[key].length > 0) {
//             newFilters[key] = initialFilters[key];
//           }
//         });
//         return newFilters;
//       });
//     }
//   }, [initialFilters]);

//   // const toggleOption = (filter, option) => {
//   //   setActiveFilters((prev) => {
//   //     const currentValues = prev[filter.id] || [];
//   //     let newValues;
      
//   //     // Handle single-select vs multi-select
//   //     if (filter.type === 'single-select') {
//   //       // For single-select, replace the entire selection
//   //       newValues = [option.value];
//   //     } else {
//   //       // For multi-select (default behavior), toggle the option
//   //       newValues = currentValues.includes(option.value)
//   //         ? currentValues.filter((v) => v !== option.value)
//   //         : [...currentValues, option.value];
//   //     }

//   //     const newFilters = { ...prev, [filter.id]: newValues };
//   //     onFilterChange(newFilters);
//   //     return newFilters;
//   //   });
//   // };

//   const toggleOption = (filter, option) => {
//     setActiveFilters((prev) => {
//       const currentValues = prev[filter.id] || [];
//       let newValues;
  
//       if (filter.type === 'single-select') {
//         // Toggle selection - clear if clicking the same option
//         newValues = currentValues.includes(option.value) 
//           ? [] 
//           : [option.value];
//       } else {
//         // Existing multi-select logic
//         newValues = currentValues.includes(option.value)
//           ? currentValues.filter((v) => v !== option.value)
//           : [...currentValues, option.value];
//       }
  
//       const newFilters = { ...prev, [filter.id]: newValues };
//       onFilterChange(newFilters);
//       return newFilters;
//     });
//   };

//   const isOptionSelected = (filterId, optionValue) => {
//     return (activeFilters[filterId] || []).includes(optionValue);
//   };

//   const resetFilters = () => {
//     const clearedFilters = filters.reduce((acc, filter) => {
//       acc[filter.id] = [];
//       return acc;
//     }, {});
//     setActiveFilters(clearedFilters);
//     setSearchQueries({});
//     onFilterChange(clearedFilters);
//   };

//   const handleSearchChange = (filterId, query) => {
//     setSearchQueries((prev) => ({
//       ...prev,
//       [filterId]: query.toLowerCase(),
//     }));
//   };

//   return (
//     <div className="common-filter">
//       <div className="d-flex flex-wrap gap-2">
//         {filters?.map((filter) => {
//           const filteredOptions = filter?.options?.filter((option) =>
//             option.label.toLowerCase().includes(searchQueries[filter.id] || "")
//           );

//           return (
//             <button
//               key={filter.id}
//               className="filter-item"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 setActiveFilterDropdown(
//                   activeFilterDropdown === filter.id ? null : filter.id
//                 );
//               }}
//             >
//               <div
//                 className="dropdown"
//                 ref={(el) => (dropdownRefs.current[filter.id] = el)}
//               >
//                 <Badge
//                   badgeContent={activeFilters?.[filter.id]?.length || 0}
//                   color="primary"
//                   overlap="circular"
//                   invisible={activeFilters?.[filter.id]?.length === 0}
//                   sx={{
//                     "& .MuiBadge-badge": {
//                       backgroundColor: "#6C5DD3", 
//                       right: 40,
//                       top: 12, 
//                       width: 18,  
//                       height: 18,    
//                       fontSize: '0.8rem', 
//                       minWidth: 16, 
//                     }
//                   }}
//                 >
//                   <div className="filter-dropdown-button">
//                     <span className="filter-label">{filter.label}</span>
//                     <ChevronDown size={16} className="ms-2" />
//                   </div>
//                 </Badge>

//                 {activeFilterDropdown === filter.id && (
//                   <div className="filter-dropdown-menu">
//                     {/* Show search input only if options exist */}
//                     {filter?.options?.length > 0 && (
//                       <input
//                         type="text"
//                         className="filter-search-input mb-2"
//                         placeholder="Search..."
//                         value={searchQueries[filter.id] || ""}
//                         onChange={(e) =>
//                           handleSearchChange(filter.id, e.target.value)
//                         }
//                         style={{ width: "90%", borderRadius: "5px", height: '35px' }}
//                         onClick={(e) => e.stopPropagation()} // Prevents dropdown from closing
//                       />
//                     )}

//                     {/* Show options or "No options available" */}
//                     <div style={{ maxHeight: "200px", overflowY: "auto" }}>
//                       {filteredOptions?.length > 0 ? (
//                         filteredOptions?.map((option) => (
//                           <button
//                             key={option.value}
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               toggleOption(filter, option);
//                             }}
//                             className={`filter-dropdown-item ${isOptionSelected(filter.id, option.value) ? "selected" : ""
//                               }`}
//                           >
//                             <span>{option.label}</span>
//                             {isOptionSelected(filter.id, option.value) && (
//                               <Check size={16} className="check-icon" />
//                             )}
//                           </button>
//                         ))
//                       ) : (
//                         <div className="no-options">No options available</div>
//                       )}
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </button>
//           );
//         })}

//         {/* Reset Button */}
//         {!clientDash && <button className="reset-button" onClick={resetFilters}>
//           ResetAll
//         </button>}
//       </div>
//     </div>
//   );
// };

// export default CommonFilter;


import React, { useState, useEffect, useRef } from "react";
import { ChevronDown, Check } from "lucide-react";
import Badge from "@mui/material/Badge";
import "./styles.scss";

export const CommonFilter = ({ filters, onFilterChange, initialFilters, clientDash }) => {
  const [activeFilters, setActiveFilters] = useState(() => {
    // Initialize with initialFilters if provided, otherwise use empty arrays
    return filters.reduce((acc, filter) => {
      acc[filter.id] = initialFilters?.[filter?.id] || [];
      return acc;
    }, {});
  });

  const [activeFilterDropdown, setActiveFilterDropdown] = useState(null);
  const [searchQueries, setSearchQueries] = useState({});
  const dropdownRefs = useRef({}); // Store refs for each dropdown

  useEffect(() => {
    const handleClickOutside = (event) => {
      let isClickInside = false;

      // Check if the clicked element is inside any active dropdown
      Object.values(dropdownRefs.current).forEach((ref) => {
        if (ref && ref.contains(event.target)) {
          isClickInside = true;
        }
      });

      if (!isClickInside) {
        setActiveFilterDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (initialFilters) {
      setActiveFilters(prevFilters => {
        const newFilters = { ...prevFilters };
        Object.keys(initialFilters).forEach(key => {
          if (initialFilters[key] && initialFilters[key].length > 0) {
            newFilters[key] = initialFilters[key];
          }
        });
        return newFilters;
      });
    }
  }, [initialFilters]);

  const toggleOption = (filter, option) => {
    setActiveFilters((prev) => {
      const currentValues = prev[filter.id] || [];
      let newValues;
  
      if (filter.type === 'single-select') {
        // Toggle selection - clear if clicking the same option
        newValues = currentValues.includes(option.value) 
          ? [] 
          : [option.value];
      } else {
        // Existing multi-select logic
        newValues = currentValues.includes(option.value)
          ? currentValues.filter((v) => v !== option.value)
          : [...currentValues, option.value];
      }
  
      const newFilters = { ...prev, [filter.id]: newValues };
      onFilterChange(newFilters);
      return newFilters;
    });
  };

  const isOptionSelected = (filterId, optionValue) => {
    return (activeFilters[filterId] || []).includes(optionValue);
  };

  const resetFilters = () => {
    const clearedFilters = filters.reduce((acc, filter) => {
      acc[filter.id] = [];
      return acc;
    }, {});
    setActiveFilters(clearedFilters);
    setSearchQueries({});
    onFilterChange(clearedFilters);
  };

  const handleSearchChange = (filterId, query) => {
    setSearchQueries((prev) => ({
      ...prev,
      [filterId]: query.toLowerCase(),
    }));
  };

  // Function to get the display label for the filter
  const getFilterDisplayLabel = (filter) => {
    if (!clientDash) {
      return filter.label;
    }

    const selectedValues = activeFilters[filter.id] || [];
    
    if (selectedValues.length === 0) {
      return filter.label;
    }

    // For single-select, show the selected option name
    if (filter.type === 'single-select' && selectedValues.length === 1) {
      const selectedOption = filter.options?.find(option => option.value === selectedValues[0]);
      return selectedOption ? selectedOption.label : filter.label;
    }

    // For multi-select, show the first selected option name with count if multiple
    if (selectedValues.length === 1) {
      const selectedOption = filter.options?.find(option => option.value === selectedValues[0]);
      return selectedOption ? selectedOption.label : filter.label;
    } else if (selectedValues.length > 1) {
      const firstSelectedOption = filter.options?.find(option => option.value === selectedValues[0]);
      return firstSelectedOption ? `${firstSelectedOption.label} (+${selectedValues.length - 1})` : filter.label;
    }

    return filter.label;
  };

  // Function to truncate long text with ellipsis
  const truncateText = (text, maxLength = 20) => {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + '...';
  };

  return (
    <div className="common-filter">
      <div className="d-flex flex-wrap gap-2">
        {filters?.map((filter) => {
          const filteredOptions = filter?.options?.filter((option) =>
            option.label.toLowerCase().includes(searchQueries[filter.id] || "")
          );

          return (
            <button
              key={filter.id}
              className="filter-item"
              onClick={(e) => {
                e.stopPropagation();
                setActiveFilterDropdown(
                  activeFilterDropdown === filter.id ? null : filter.id
                );
              }}
            >
              <div
                className="dropdown"
                ref={(el) => (dropdownRefs.current[filter.id] = el)}
              >
                <Badge
                  badgeContent={activeFilters?.[filter.id]?.length || 0}
                  color="primary"
                  overlap="circular"
                  invisible={clientDash || activeFilters?.[filter.id]?.length === 0}
                  sx={{
                    "& .MuiBadge-badge": {
                      backgroundColor: "#34A853", 
                      right: 40,
                      top: 12, 
                      width: 18,  
                      height: 18,    
                      fontSize: '0.8rem', 
                      minWidth: 16, 
                    }
                  }}
                >
                  <div className="filter-dropdown-button">
                    <span className="filter-label" title={getFilterDisplayLabel(filter)}>
                      {truncateText(getFilterDisplayLabel(filter))}
                    </span>
                     <ChevronDown size={16} className="ms-2" />
                  </div>
                </Badge>

                {activeFilterDropdown === filter.id && (
                  <div className="filter-dropdown-menu">
                    {/* Show search input only if options exist */}
                    {filter?.options?.length > 0 && (
                      <input
                        type="text"
                        className="filter-search-input mb-2"
                        placeholder="Search..."
                        value={searchQueries[filter.id] || ""}
                        onChange={(e) =>
                          handleSearchChange(filter.id, e.target.value)
                        }
                        style={{ width: "90%", borderRadius: "5px", height: '35px' }}
                        onClick={(e) => e.stopPropagation()} // Prevents dropdown from closing
                      />
                    )}

                    {/* Show options or "No options available" */}
                    <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                      {filteredOptions?.length > 0 ? (
                        filteredOptions?.map((option) => (
                          <button
                            key={option.value}
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleOption(filter, option);
                            }}
                            className={`filter-dropdown-item ${isOptionSelected(filter.id, option.value) ? "selected" : ""
                              }`}
                          >
                            <span>{option.label}</span>
                            {isOptionSelected(filter.id, option.value) && (
                              <Check size={16} className="check-icon" />
                            )}
                          </button>
                        ))
                      ) : (
                        <div className="no-options">No options available</div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </button>
          );
        })}

        {/* Reset Button */}
        {!clientDash && <button className="reset-button" onClick={resetFilters}>
          ResetAll
        </button>}
      </div>
    </div>
  );
};

export default CommonFilter;
